var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlaytnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 502,
    height: 497,
    viewBox: "0 0 5020 4970",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l7hfOaUrgnF5cCiE6UHexmX",
    fill: "rgb(78,67,61)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pwNbk953M",
    d: "M2485 4748 c-121 -52 -295 -125 -425 -178 -69 -28 -165 -68 -215 -89 -49 -22 -180 -76 -290 -121 -350 -145 -510 -212 -518 -220 -5 -4 121 -137 280 -294 158 -158 500 -498 759 -756 259 -259 477 -470 485 -470 7 0 141 128 298 284 157 157 501 498 764 759 l477 474 -57 26 c-32 14 -164 69 -293 122 -129 53 -248 103 -265 110 -16 7 -86 36 -155 65 -69 28 -144 60 -167 71 -24 10 -46 19 -51 19 -5 0 -32 11 -60 25 -29 14 -58 25 -65 25 -7 0 -17 4 -23 9 -5 5 -40 21 -79 36 -38 15 -101 41 -140 57 -38 17 -88 39 -110 48 -67 29 -77 29 -150 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17V6h10PX",
    d: "M852 4008 c-67 -72 -191 -236 -228 -303 -6 -11 -33 -59 -61 -106 -104 -180 -181 -389 -237 -644 -22 -100 -26 -141 -32 -310 l-6 -150 1015 -1010 c558 -556 1038 -1032 1066 -1060 l52 -50 -56 135 c-32 74 -91 218 -132 320 -41 102 -81 199 -88 215 -8 17 -48 113 -90 215 -42 102 -83 198 -91 214 -8 16 -14 33 -14 38 0 4 -9 27 -19 51 -32 70 -77 176 -125 294 -25 62 -52 128 -60 145 -8 18 -51 123 -97 233 -107 261 -227 552 -244 590 -7 17 -48 116 -90 220 -43 105 -86 208 -95 230 -10 22 -61 146 -114 275 -54 129 -106 254 -116 277 -11 24 -20 45 -20 48 0 6 -26 69 -58 139 l-18 39 -42 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piQYPNhQ7",
    d: "M3966 3791 c-144 -143 -492 -489 -775 -770 l-515 -511 25 -27 c13 -15 123 -126 244 -246 121 -120 459 -456 751 -747 291 -292 535 -530 541 -530 34 0 252 302 362 502 67 123 161 381 196 543 40 180 44 233 40 545 -3 327 -7 356 -69 578 -25 88 -129 366 -146 387 -4 6 -25 42 -45 80 -87 161 -304 455 -338 455 -6 0 -128 -117 -271 -259z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FMclL9b5",
    d: "M1183 3760 c11 -28 125 -305 187 -455 59 -142 98 -235 203 -490 163 -397 219 -532 227 -550 5 -11 31 -74 58 -140 92 -225 164 -400 182 -440 30 -68 67 -157 89 -215 12 -30 26 -64 31 -75 5 -11 32 -76 60 -145 46 -111 130 -315 265 -640 24 -58 65 -157 91 -220 26 -63 50 -119 54 -123 5 -5 23 -2 41 6 19 9 63 27 99 42 36 14 74 30 85 35 11 5 83 34 160 65 77 31 154 63 170 70 28 12 106 45 430 177 66 27 129 53 140 58 11 6 89 38 174 73 85 34 156 67 158 72 2 6 -648 659 -1444 1452 -1659 1651 -1468 1462 -1460 1443z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytnLogo);
export default __webpack_public_path__ + "static/media/klaytn_logo.9809d8f2410e9a46a3299e7f154e3785.svg";
export { ForwardRef as ReactComponent };